'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function normalize(input) {
  const initialValue = !Array.isArray(input) ? {} : [];
  return Object.entries(input).reduce((output, [key, value]) => {
    const newValue = !!value && typeof value === "object" ? normalize(value) : value;
    if (typeof key === "string") {
      let newKey;
      if (isUpperCase(key)) {
        newKey = key.toLowerCase();
      } else {
        const firstChar = (key[0] || "").toLowerCase();
        newKey = `${firstChar}${key.substr(1, key.length)}`;
      }
      output[newKey] = newValue;
    } else {
      output.push(newValue);
    }
    return output;
  }, initialValue);
}
function isUpperCase(str) {
  return str === str.toUpperCase();
}

exports.normalize = normalize;
